/**
 * ehr#341 / #343 - window events the app shell fires when its live check sees a teammate's change
 * (the sidebar badges poll the stamps; an open page listens instead of polling a second time).
 */
export const TASKS_REMOTE = 'credify:tasks-remote';
export const NOTES_REMOTE = 'credify:notes-remote';
/** #107 - this tab created, changed or deleted a task (lib/api.ts fires it after any /tasks write). */
export const TASKS_CHANGED = 'credify:tasks-changed';
/** credifyfbs#313 - this tab saved, paused, copied or deleted a form rule (lib/api.ts fires it). */
export const RULES_CHANGED = 'credify:rules-changed';
